import { render, staticRenderFns } from "./CardGamePage.vue?vue&type=template&id=384ba09a&scoped=true&"
import script from "./CardGamePage.vue?vue&type=script&lang=js&"
export * from "./CardGamePage.vue?vue&type=script&lang=js&"
import style0 from "./CardGamePage.vue?vue&type=style&index=0&id=384ba09a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384ba09a",
  null
  
)

export default component.exports